import { makeAutoObservable } from "mobx";
import {
    deleteWorkingSlot,
    getWorkingSlotById,
    saveOrUpdate,
    pagingWorkingSlot,
} from 'app/services/WorkingSlotService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { WorkingSlot } from "app/common/Model/WorkingSlot";
import { checkSearchObject } from "app/common/LocalFunction";

export default class WorkingSlotStore {
    listAllWorkingSlot = [];
    searchWorkingSlot = new SearchObject();
    pageWorkingSlot = null;
    selectedWorkingSlot = new WorkingSlot();
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingWorkingSlot = async () => {
        return await pagingWorkingSlot(this.searchWorkingSlot)
            .then(({ data }) => {
                this.pageWorkingSlot = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi", "Thông báo")
            })
    }

    handleChangeFormSearch = (searchWorkingSlot) => {
        this.searchWorkingSlot = checkSearchObject(this.searchWorkingSlot, searchWorkingSlot);
        this.pagingWorkingSlot();
    }

    handleOpenFormCreateOrEdit = (workingSlotId) => {
        if (Boolean(workingSlotId)) {
            getWorkingSlotById(workingSlotId).then(({ data }) => {
                this.selectedWorkingSlot = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedWorkingSlot = new WorkingSlot();
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateWorkingSlot = (workingSlot, { setSubmitting }) => {
        saveOrUpdate(workingSlot)
            .then(() => {
                this.selectedWorkingSlot = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingWorkingSlot();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (workingSlot) => {
        this.selectedWorkingSlot = { id: workingSlot?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteWorkingSlot(this.selectedWorkingSlot?.id)
            .then(() => {
                if (this.searchWorkingSlot?.pageIndex > 1 && this.pageWorkingSlot?.content?.length === 1) {
                    this.searchWorkingSlot.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingWorkingSlot();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi", "Thông báo");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchWorkingSlot = new SearchObject();
        this.pageWorkingSlot = null;
        this.selectedWorkingSlot = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    //for choosing workingSlot in ChooseWorkingSlotPopup.jsx 
    listWorkingSlot = [];
    workingSlotIdSet = null;

    isValidWorkingSlot = workingSlot => {
        if (workingSlot && workingSlot?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addWorkingSlot = workingSlot => {
        if (!this.isValidWorkingSlot(workingSlot)) return;
        this.listWorkingSlot.push(workingSlot);
        this.workingSlotIdSet.add(workingSlot?.id);
    }

    initializelistWorkingSlot = workingSlots => {
        this.workingSlotIdSet = new Set();
        this.listWorkingSlot = [];
        if (workingSlots && workingSlots?.length > 0) {
            for (let i = 0; i < workingSlots.length; i++) {
                this.addWorkingSlot(workingSlots[i]);
            }
        }
    }

    removeWorkingSlot = workingSlot => {
        if (!this.isValidWorkingSlot(workingSlot)) return;
        if (this.workingSlotIdSet.has(workingSlot?.id)) {
            this.workingSlotIdSet.delete(workingSlot?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = workingSlot => {
        if (!this.isValidWorkingSlot(workingSlot)) return;
        return this.workingSlotIdSet.has(workingSlot?.id);
    }

    getWorkingSlotIdSet = () => {
        return this.workingSlotIdSet;
    }

    getListWorkingSlot = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listWorkingSlot && this.listWorkingSlot?.length > 0) {
            for (let i = 0; i < this.listWorkingSlot.length; i++) {
                const workingSlot = this.listWorkingSlot[i];
                if (this.isExist(workingSlot) && !bufferIdSet.has(workingSlot?.id)) {
                    data.push(workingSlot);
                    bufferIdSet.add(workingSlot?.id);
                }
            }
        }
        this.listWorkingSlot = data;
        return data;
    }

}
